import {Pagination} from "antd";
import React from "react";

interface ITableSize {
  page: number;
  page_size: number;
};

interface ITablePaginator {
  queryParams: ITableSize;
  setQueryParams: (value: any) => void;
  total: number | undefined;
};

export const TablePaginator: React.FC<ITablePaginator> = (props) => {

  const handleChange = (page: number, pageSize: number) => {
    const paramCopy = {...props.queryParams};
    paramCopy.page_size = pageSize;
    paramCopy.page = page;
    props.setQueryParams(paramCopy);
  };

  return (
    <Pagination
      current={props.queryParams.page}
      pageSize={props.queryParams.page_size}
      pageSizeOptions={[50, 100, 200, 500, 1000]}
      showSizeChanger
      showQuickJumper
      showPrevNextJumpers
      total={props.total}
      onChange={handleChange}
    />
  );
};
